function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.4211 12H16.5789C15.7093 12 15 12.7093 15 13.5789V38.3158H35V13.5789C35 12.7093 34.2907 12 33.4211 12ZM26.5789 24.1053V20.9474H31.3158V24.1053H26.5789ZM31.3158 26.2105V29.3684H26.5789V26.2105H31.3158ZM26.5789 18.8421V15.6842H31.3158V18.8421H26.5789ZM18.6842 24.1053V20.9474H23.4211V24.1053H18.6842ZM23.4211 26.2105V29.3684H18.6842V26.2105H23.4211ZM18.6842 18.8421V15.6842H23.4211V18.8421H18.6842ZM18.6842 31.4737H23.4211V34.6316H18.6842V31.4737ZM26.5789 31.4737H31.3158V37.2632H26.5789V31.4737Z"
});

function SvgIc7783F441Ea4A490EA4446Bf135772753(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc7783F441Ea4A490EA4446Bf135772753);
export default ForwardRef;